// --------------------------------------------------------------
// Created On: 2024-09-15
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { Fragment } from "react";
import IconTooltip from "../../../../../../components/IconTooltip/IconTooltip";
import {
  MONITORING_DEVICE_SENSOR_CARD_TYPE,
  ACTIVE_DTC_CARD_TYPE,
  HISTORY_GRAPH_CARD_TYPE,
} from "../../../../../../constants/templates";
import styles from "./SpecialCardTooltips.module.scss";

// Displays information about the current dynamic card.
export default function SpecialCardTooltips(props: Props): Component {
  // Get the correct tooltip image URL based on the card type.
  function getTooltipImageUrl(cardTypeName: string | null): string {
    switch (cardTypeName) {
      case MONITORING_DEVICE_SENSOR_CARD_TYPE:
        return "/images/template_dynamic_sensors_example.png";
      case ACTIVE_DTC_CARD_TYPE:
        return "/images/template_dynamic_dtc_example.png";
      case HISTORY_GRAPH_CARD_TYPE:
        return "/images/template_dynamic_history_graph_example.png";
      default:
        return "";
    }
  }

  if (props.cardTypeId === null) {
    return <Fragment />;
  } else {
    return (
      <div className={`${styles.body} col-auto`}>
        <IconTooltip
          id={`card-type-description-tooltip-${props.cardTypeId}`}
          icon="info-circle"
          message={props.cardTypeDescription || ""}
          color="var(--info-tooltip)"
        />
        <span className="me-2" />

        <IconTooltip
          id={`card-type-image-tooltip-${props.cardTypeId}`}
          icon="picture-o"
          imageUrl={getTooltipImageUrl(props.cardTypeName)}
          imageAlt="Dynamic card example."
          imageMaxWidth={1000}
          color="var(--info-tooltip-image)"
        />
      </div>
    );
  }
}

interface Props {
  cardTypeId: number | null;
  cardTypeName: string | null;
  cardTypeDescription: string | null;
}
